"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
// import { diveKeyboard } from '@voyage/input/diveKeyboard-sidecar'
var _isMoveCameraMouseDown = false;
var _mx = 0;
var _my = 0;
var _sx = 0;
var _sy = 0;
function update(obj) {
    // Uncomment to disable camera movement on main menu
    // if (voyageMenuMain.get().isOpen) {
    //   return
    // }
    if (clickEater_sidecar_1.clickEater.isCursorEaten()) {
        return;
    }
    var ap = common_sidecar_1.common.getPhaserScene().game.input.activePointer;
    if (ap.rightButtonDown()) {
        if (!_isMoveCameraMouseDown) {
            _isMoveCameraMouseDown = true;
            _mx = ap.x;
            _my = ap.y;
            _sx = obj.cameraX;
            _sy = obj.cameraY;
        }
        voyageCamera_sidecar_1.voyageCamera.setCameraXY(_sx + -(ap.x - _mx), _sy + -(ap.y - _my));
    }
    else {
        _isMoveCameraMouseDown = false;
    }
}
exports.update = update;
